<template>
    <div
        class="selection-bar"
        data-selected-bar
        style="position: sticky; bottom: 0px"
    >
        <div class="selection-bar__header">
            <div class="container selection-bar__header-content">
                <h2 v-text="`Wybrano: ${typeWord}`" class="selection-bar__heading mb-0" />

                <div class="d-block d-lg-flex mt-3 mt-lg-0 align-items-center">
                    <the-btn
                        class="btn btn-danger"
                        text="Wyczyść zaznaczone"
                        @click="$store.dispatch('selectAllSettlements', false)"
                    />
                    <span class="dropup">
                        <the-btn
                            v-click-outside="hideDropdown"
                            class="btn btn-secondary ml-3"
                            id="dropdownDownloadNotes"
                            data-toggle="dropdown"
                            text="Pobierz"
                            icon="Download"
                            @click="showDropdown = !showDropdown"
                        >
                            <a-icon icon="Dropdown" />
                        </the-btn>
                        <div
                            class="dropdown-menu dropdown-menu-right dropdown-menu-bottom"
                            :class="{ show: showDropdown }"
                            aria-labelledby="dropdownDownloadNotes"
                        >
                            <the-btn
                                v-if="activeTab !== 2 && showOption('Report')"
                                class="dropdown-item btn-sm text-md"
                                text="Raporty rozliczeniowe - xls"
                                @click="downloadSettlements(`Report`)"
                            />
                            <the-btn
                                v-if="showOption('Note')"
                                class="dropdown-item btn-sm text-md"
                                text="Dokumenty księgowe - pdf"
                                @click="downloadSettlements('Note')"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        showDropdown: false
    }),

    props: {
        data: {
            type: Array,
            required: true
        }
    },

    computed: {
        typeWord() {
            return this.$options.filters.plurals(
                this.selectedSettlementsCount,
                'dokument',
                'dokumenty',
                'dokumentów'
            )
        },

        selectedSettlementsCount() {
            return this.$store.getters.getSelectedSettlementsCount
        },

        activeTab() {
            return this.$store.getters.getSettlementsActiveTab
        }
    },

    methods: {
        downloadSettlements(bundleType) {
            this.$store.dispatch('downloadSettlements', { bundleType })
        },

        hideDropdown() {
            this.showDropdown = false
        },

        showOption(bundleType) {
            return this.$store.getters.getSelectedSettlementsIds(bundleType).length > 0
        }
    }
}
</script>
